import axios, { AxiosResponse } from 'axios';
import { useCallback, useState } from 'react';
import { iTagShort__API } from '../apiSchema';
import { getApiLink } from '../api';
import { iTag, Tag } from '../models/Tag';

async function getSuggestedTags(): Promise<iTag[]> {
    const response: AxiosResponse<iTagShort__API[]> = await axios.get(getApiLink('api/ContentWatch/SuggestedTags'));

    return response.data.map((p) => new Tag({ apiModel: p }));
}

export default function useSuggestedTags() {
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    const fetchSuggestedTags = useCallback(async (): Promise<iTag[]> => {
        setIsLoading(true);
        setIsError(false);

        try {
            return await getSuggestedTags();
        } catch {
            setIsError(true);
            return [];
        } finally {
            setIsLoading(false);
        }
    }, []);

    return {
        fetchSuggestedTags,
        isLoading,
        isError
    };
}
